import { render, staticRenderFns } from "./Attendee.vue?vue&type=template&id=39cd90a4&"
import script from "./Attendee.vue?vue&type=script&lang=js&"
export * from "./Attendee.vue?vue&type=script&lang=js&"
import style0 from "./Attendee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports